"use strict";

// Definition of concrete types and its parameters
const concrete = Mat.Concrete.types;
// Definition of reinforcment steel types and its parameters
const steel = Mat.Reinforcement.steelTypes;

// Variable initialisation
var cType = 1;  // Primary concrete type (ID)
var sType = 0;  // Primary steel type (ID)
var rX = 0;     // ID of Point plot...
var pos = 0;    // Slider Position
var showMrd = false; // show mrd...
var data = {mat: {}, geo: {}, cl: {}, plot: {}}; // Data Struct containing all informations about materials, geometry, calculations, plots

//Language
var url = window.location.href;
if(url.indexOf("/en/") !== -1) {
    var lang = "en";
} else {
    var lang = "de";
}

// Function if DropDown of Concrete Type get changed
$("#conType").change(function () {
    let Ec; // Youngs-Modulous concrete
    cType = parseInt($("#conType").val()); // Get chosen concrete type from DropDown
    // Write new values
    $("#conFctm").html(concrete[cType].fctm);
    $("#conFcd").html(concrete[cType].fcd);
    Ec = Math.round(Math.pow(concrete[cType].fcm, (1 / 3)) * 10); // Calculate Youngs modulus
    $("#conEc").html(Ec);
    chgWertigkeit(); //Calculate new "Wertigkeit n"
});

$("#refType").change(function () {
    let Ec; // Youngs-Modulous concrete
    sType = parseInt($("#refType").val()); // Get chosen concrete type from DropDown
    // Write new values
    $("#refFsd").html(steel[sType].fsd);
    chgWertigkeit(); //Calculate new "Wertigkeit n"
});

// Function that calculates "Wertigkeit n" used if DropDown of Concrete or Reinforcment type changes
function chgWertigkeit() {
    // Calculate Wertigkeit and write it in DOM
    $("#n").html(Math.round(Mat.Reinforcement.es * 1000 / (Math.pow(concrete[cType].fcm, (1 / 3)) * 100)) / 100);
}

// Initialise Slider
var xsld = document.getElementById('XXmax');

noUiSlider.create(xsld, {
    start: [0],
    range: {
        'min': 0,
        'max': 1000
    },
    padding: null,
    tooltips: true,
    step: 1,
    pips: {
        mode: 'count',
        values: 11,
        density: 1
    },
    format: {
        to: function(value){
            return Math.round(value*10)/10;
        },
        from: function(value){
            return value;
        }
    }
});


updateCalc();

if(window.checkMobile() == true){
    xsld.noUiSlider.on('set', updatePointPosition);
}else{
    xsld.noUiSlider.on('slide', updatePointPosition);
}

function updatePointPosition(values, handle, unencoded, tap, positions) {
    $("#showMrd").prop('checked', false);
    rX = Math.round(((values[0] / 1000) * (data.cl.X._data.length - 1)));
    pos = values[0];
    updateCalc();
}

// If anything with class="updCalc" get changed call function updateCalc()
$(".updCalc, #refAs, #algD, #conWidth, #conHeight").change(function() {
    updateCalc();
});

$("#limFc").change(function() {
    $("#showMrd").prop('checked', false);
    updateCalc();
    updatePointPosition([xsld.noUiSlider.get()]);
});

$("#showMrd").click(function() {
    //rX = data.cl.X._data.length - 1;
    $("#limFc").prop('checked', false);
    updateCalc();
    if(!$("#showMrd").prop('checked')) {
        updatePointPosition([xsld.noUiSlider.get()]);
    }
    /* xsld.noUiSlider.set([1000]); */
});

// Update Calculation
function updateCalc() {
    // Initialisation of variables
    let Ec, Es, As, d, b, h, n, rho, zc, I, x_0, EI_II, M_r, M_Rd, X_Rd, X, X_r, M, i, o, X_r2, X_y, i_r, x_eff, eps_c,
        eps_s, eps_cc, dx, scFac, scFacEps, scFacX,  xAxisInf, xAxisSup, limFc, iSy, iCRd, scX, x;

    Ec = Math.pow(concrete[cType].fcm, (1 / 3)) * 10000; // Calculate Youngs-Modulous of concrete
    Es = Mat.Reinforcement.es * 1000; // Get Youngs-Modulous of reinforcment into Es
    //let fsd = steel[sType].fsd;

    // Get values from input fields of As (Bewehrungsquerschnittsfläche), d (Statische Höhe), b (Breite) & h (Höhe)
    As = parseInt($("#refAs").val());
    d = parseInt($("#algD").val());
    b = parseInt($("#conWidth").val());
    h = parseInt($("#conHeight").val());

    // Bewehrungsgehalte
    $('#rho').html(Math.round(As/(b*d)*10000)/100);
    $('#omega').html(Math.round(As/(b*d)*(steel[sType].fsd/concrete[cType].fcd)*10000)/100);

    if(d > h){
        document.getElementById('algD').classList.add('is-invalid');
        document.getElementById('conHeight').classList.add('is-invalid');
        document.getElementById('Ctrl').classList.add('focus');
        if(lang=="en") {
            alert('The structural height d cannot be greater than the height h!');
        } else {
            alert('Die statische Höhe d kann nicht grösser als die Höhe h sein!');
        }
        
        return;
    }else{
        document.getElementById('algD').classList.remove('is-invalid');
        document.getElementById('conHeight').classList.remove('is-invalid');
        document.getElementById('Ctrl').classList.remove('focus');
    }

    // Prüfung Duktilität
    var xMrd = As*steel[sType].fsd/(0.85*b*concrete[cType].fcd);
    if( xMrd/d > 0.5) {
        document.getElementById('Ctrl').classList.add('focus');
        if(lang=="en") {
            alert('The ratio of the pressure zone height to the static height (x/d) exceeds 0.5. This condition is inadmissible because ductility is not guaranteed.');
        } else {
            alert('Das Verhälnis der Druckzonenhöhe zur statischen Höhe (x/d) übersteigt 0.5. Dieser Zustand ist unzulässig, da die Duktiliät nicht gewährleistet ist.');
        }
        
        return;
    } else {
        document.getElementById('Ctrl').classList.remove('focus');
    }

    // Begrenzung fc
    limFc = $("#limFc").prop("checked"); // Betonspannungen limitieren auf fcd (true/false)
    showMrd = $("#showMrd").prop("checked"); // Mrd zeigen...

    n = Es / Ec; // Calc "Wertigkeit"
    rho = As / (d * b); // Calc "Bewehrungsgehalt"

    zc = ((b * Math.pow(h, 2)) / 2 + As * d * (n - 1)) / (b * h + As * (n - 1)); // Calc "Schwerpunkt (n-Verfahren)"
    I = (b * Math.pow(h, 3)) / 12 + Math.pow((h / 2 - zc), 2) * b * h + As * (n - 1) * Math.pow((d - zc), 2); // Calc "Flächenträgheitsmoment"

    x_0 = d * (Math.sqrt(Math.pow((n * rho), 2) + 2 * rho * n) - rho * n); // Calc "Druckzonenhöhe Zustand II - gerissen-elast"
    EI_II = As * Es * (d - x_0) * (d - x_0 / 3); // EI_II gerissen elast

    M_r = concrete[cType].fctm * I / (h - zc); // Rissmoment
    M_Rd = As * steel[sType].fsd * (d - As * steel[sType].fsd / (2 * b * concrete[cType].fcd)); // Widerstandmoment

    // Krümmung bei Erreichen Betonbruchdehnung
    // Solve it
    let x_start = h/2;
    let diff = x_start;
    let x_new = 0;
    let x_el = 0;

    if(!limFc || showMrd) {
        x = xMrd;
    } else {
        x = As * steel[sType].fsd / ((1-concrete[cType].fcd/(0.003*Ec))*concrete[cType].fcd*b + Math.pow(concrete[cType].fcd,2)*b/(2*0.003*Ec));
    }

/*     while (diff > 0.1) {
        x_el = x_start/0.003 * concrete[cType].fcd / Ec;
        x_new = 1/(steel[sType].fsd * b) * (steel[sType].fsd * As - x_el/2*concrete[cType].fcd*b) + x_el;
        diff = Math.abs(x_new - x_start);
        x_start = (x_start + x_new) / 2;
        console.log(x_start, x_new, diff);
    } */

    X_Rd = 0.003 / x;
    /* console.log(x); */

    // Krümmung für Rechtecksblock
    // X_Rd = 0.003 / (As * steel[sType].fsd / (0.85 * b * concrete[cType].fcd));

    // Prüfen ob Mindestbewehrung eingelegt (Mr < MRd)
    if(M_r > M_Rd){
        document.getElementById('refAs').classList.add('is-invalid');
        document.getElementById('Ctrl').classList.add('focus');
        if(lang=="en") {
            alert('Brittle failure in case of cracking!\nThe cracking moment is greater than the bending resistance.\n\nNot enough reinforcement available (keyword: minimum reinforcement).');
        } else {
            alert('Sprödes Versagen bei Rissbildung!\nDas Rissmoment ist grösser als der Biegewiderstand.\n\nNicht genügend Bewehrung vorhanden (Stichwort: Mindestbewehrung).');
        }
        
        return;
    }else{
        document.getElementById('refAs').classList.remove('is-invalid');
        document.getElementById('Ctrl').classList.remove('focus');
    }

    X = math.range(0, X_Rd, X_Rd / 1000); // Vektor aller Krümmungspunkte (für Plot)
    X_r = M_r / (Ec * I); // Krümmung beim reissen

    M = math.zeros(X.size()[0]); // Vektor aller Momente zugehörig zum Krümmungsvektor

    i = 0; //Iterationsvariable

    // Berechne alle Momente bis zum Erreichen des Reissens
    while (X._data[i] < X_r) {
        M._data[i] = Ec * I * X._data[i]; // M = E*I*X
        i++;
    }

    i_r = i; //Iterationsschritt (id) beim Reissen
    X_r2 = M_r / EI_II; //Krümmung bei "Ende" Reissen
    X_y = M_Rd / EI_II; // Fliesskrümmung

    let pmax = Math.round((1-X_y/X_Rd)*1000);

    if(!limFc) {
        if (pmax < 0) pmax = 0;
        xsld.noUiSlider.updateOptions({
            padding: [0, Math.round(pmax)]
        });
        // Set slider to that position
        
    }else{
        xsld.noUiSlider.updateOptions({
            padding: [0, 0]
        })
    }

    //
    // console.log(showMrd, $("#limFc").prop('checked'));
    if (showMrd && $("#limFc").prop('checked')) {
        if(pos > pmax) {
            xsld.noUiSlider.set(pmax);
        }
    }

    // Ebene bei M_r
    while (X._data[i] < X_r2) {
        M._data[i] = M_r;
        i++;
    }

    // Momente bis erreichen Fliessen
    iSy = 0;
    while (X._data[i] < X_y) {
        M._data[i] = EI_II * X._data[i];
        i++;
    }

    // Fliessen füllen mit M_Rd
    iCRd = 0;
    for (o = i; o < X._data.length; o++) {
        M._data[o] = M_Rd;
    }

    // Berechnung der Druckzonenhöhen...
    x_eff = math.multiply(math.ones(X._data.length), x_0); // Vector of "Druckzonenhöhen"
    x_eff._data.fill(zc, 0, i_r - 1); //Array (Vector) füllen mit Druckzonenhöhe (Schwerpunkt) zc bis zum Reissen

    if (limFc){

        //Find...
        iSy = X._data.findIndex(function (result) {
            return result > ((steel[sType].fsd/Es)/(d-x_0));
        });

        iCRd = X._data.findIndex(function (result) {
            return result > ((concrete[cType].fcd/Ec)/x_0);
        });

        if(iSy === -1) {
            if(lang=="en") {
                alert('Calculation model invalid');
            } else {
                alert('Berechnungsmodell ungültig');
            }
            
            $('#limFc').prop('checked', false);
            return;
        }

        // Falls Bewehrung fliesst, bevor Betonfestigkeit erreicht wird
        if (iSy < iCRd){
            i = iSy;
            // Für alle Krümmungswerte bis Erreichen Betonfestigkeit:
            while(x_eff._data[i]*X._data[i] < concrete[cType].fcd/Ec){
                x_eff._data[i] = math.sqrt((2*As*steel[sType].fsd)/(Ec*X._data[i]*b)); //Dreieckiger Spannungsblock...
                let Mtmp = As*steel[sType].fsd*(d-x_eff._data[i]/3)
                if(Mtmp > M_r) {
                    M._data[i] = Mtmp; // Moment mit neuem Hebelarm...
                } else {
                    M._data[i] = M_r;
                }
                i++;
            }
        }else{
            i = iCRd;
        }

        //Für alle Krümmungen von Erreichen Betonfestigkeit bis Erreichen Betonbruchdehnung...
        for(i=i; i < X._data.length; i++){
            // TODO: Evtl Parabel einfügen?
            // Berechnung Druckzonenhöhe
            x_eff._data[i] = (b*Math.pow(concrete[cType].fcd,2)+2*d*Ec*As*Es*Math.pow(X._data[i],2))/(2*(b*concrete[cType].fcd+As*Es*X._data[i])*Ec*X._data[i]);

            if(X._data[i]*(d-x_eff._data[i]) > steel[sType].fsd/Es){
                x_eff._data[i] = As*steel[sType].fsd/(b*concrete[cType].fcd)+concrete[cType].fcd/(2*X._data[i]*Ec);
            }

            let Fc = concrete[cType].fcd*b*(x_eff._data[i]-concrete[cType].fcd/(2*X._data[i]*Ec));
            let zcc = b*(concrete[cType].fcd*Math.pow(x_eff._data[i],2)/2-concrete[cType].fcd*Math.pow((concrete[cType].fcd/(X._data[i]*Ec)),2)/6)/Fc;
            let Mtmp = M._data[i] = Fc*(zcc+d-x_eff._data[i]);

            if(Mtmp > M_r) {
                M._data[i] = Mtmp; // Moment mit neuem Hebelarm...
            } else {
                M._data[i] = M_r;
            }
        }
    }

    let pointX = 0;
    let pointY = 0;

    if(showMrd) {
        pointX = convData([0.003/xMrd], 6);
        pointY = convData([M_Rd], -6);
        // console.log(pointX, pointY);
    } else {
        pointX = convData([X._data[rX]],6);
        pointY = convData([M._data[rX]],-6);
        // console.log(pointX, pointY);
    }

    // Vektoren für M-X Diagramm gefüllt... Folglich plotten M-X Diagramm
    let pltData = {
        Data: [
            {
                x: convData(X._data,6), //Convert from - to micro
                y: convData(M._data,-6), //Convert from Nmm to kNm
                mode: 'lines',
                line: {
                    width: 1
                }
            },
            {
                x: pointX,
                y: pointY,
                mode: 'markers',
                marker: {
                    color: 'rgb(255, 0, 0)',
                    size: 5
                }

            },
            {
                x: [convData(X_r,6), convData((X_r/M_r)*M_Rd,6)],
                y: [convData(M_r,-6), convData(M_Rd,-6)], //Convert from Nmm to kNm
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(100,100,100)',
                    dash: 'dot'
                }
            },
            {
                x: [0, convData(X_r2,6)],
                y: [0, convData(M_r,-6)], //Convert from Nmm to kNm
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(100,100,100)',
                    dash: 'dot'
                }
            }
        ],
        Layout: {
            hovermode: false,
            height: 350,
            margin: {
                l: 60,
                r: 0,
                b: 40,
                t: 30,
                pad: 0
            },
            xaxis: {
                title: 'χ [10<sup>-6</sup> mm<sup>-1</sup>]',
                rangemode: 'tozero',
                range: [0, convData(math.max(X)*1.1,6)],
            },
            yaxis: {
                title: 'M [kNm]',
                rangemode: 'tozero',
                range: [0, convData(M_Rd*1.1,-6)],
            },
            showlegend: false
        },
    };

    // If at cracking > Punkt für Kraftgesteuerter Versuch hinzufügen...
    let disptxt = "⟶ Weggesteuert";
    if(lang == "en") {
        disptxt = "⟶ Displacement-controlled";
    }
    if(X._data[rX] > X_r && X._data[rX] < X_r2) {
        pltData.Data.push({
            x: convData([X._data[rX]],6),
            y: convData([M_r/X_r2*X._data[rX]],-6),
            mode: 'markers+text',
            marker: {
                color: 'rgb(242, 119, 24)',
                size: 5
            },
            text: [disptxt],
            textposition: 'right'
        });
    }

    if(window.checkMobile() == true){
        pltData.Layout.dragmode = false;
    }

    Plotly.react("plotMX", pltData.Data, pltData.Layout, pltConfig);

    //Write plot data in data variable...
    data.plot = {
        MX: pltData // Property MX (Momenten Krümmung Plot)
    };

    // Write calculated Moments, "Krüummungen" and Risskrümmung in data Struct
    data.cl = {
        M: M,
        X: X,
        X_r: X_r
    };

    // Calulate offset for stress plot
    dx = 150; // Standard offset...
    //dx = eps_c._data[eps_c._data.length - 1] / x_eff._data[x_eff._data.length - 1] * (h - x_eff._data[x_eff._data.length - 1]) * 10000 + dx;
    scFac = 5; // Scale Factor...
    scFacEps = 10000;
    scFacX = 1;
    scX = false;

    // Calc extreme for mrd...
    var eps_sup = 0.003;
    var eps_inf = eps_sup/xMrd*(h-xMrd);

    //Check eps scale factor...
    if(eps_inf*scFacEps*scFacX > dx-10) {
        scFacEps = (dx-10)/(eps_inf*scFacX);
        console.info("Der Vergrösserungsfaktor für die Darstellung der Dehnungsebene wurde verändert!");
    }

    //scX = $("#scXAxis").prop("checked");

    // Falls mrd angezeigt werden soll...
    if(showMrd){
        eps_s = eps_sup/xMrd*(d-xMrd);

        xAxisInf = -eps_sup * scFacEps; // Lower limit of xAxis
        xAxisSup = steel[sType].fsd*1.1 / scFac + dx; // Upper limit of xAxis

        var nAxis = { //Neutral axis...
            x: [xAxisInf, xAxisSup],
            y: [h - xMrd, h - xMrd]
        };

        var eps = {
            QS: { // Strain values for cross section
                x: [0, -eps_sup * scFacEps * scFacX, eps_inf * scFacEps * scFacX, 0],
                y: [h, h, 0, 0]
            },
            s: { // Strain values for reinforcement
                x: [0, eps_s*scFacEps * scFacX],
                y: [h-d, h-d]
            }
        };
        
        var sig = {
            s: { // Stress values for reinforcement
                x: [dx, steel[sType].fsd/scFac*scFacX+dx],
                y: [h-d, h-d]
            },
            c: {
                x: [dx, concrete[cType].fcd/scFacX+dx, concrete[cType].fcd/scFacX+dx, dx],
                y: [h, h, h-0.85*xMrd, h-0.85*xMrd]
            }
        };

        $('#x').html(Math.round(xMrd));
        $('#xd').html(Math.round(xMrd/d*100)/100);
        
        if(xMrd/d <= 0.35){
            document.getElementById('xd').classList.remove('alert-warning');
            document.getElementById('xd').classList.remove('alert-danger');
        }else if(xMrd/d <= 0.5){
            document.getElementById('xd').classList.add('alert-warning');
            document.getElementById('xd').classList.remove('alert-danger');
        }else{
            document.getElementById('xd').classList.remove('alert-warning');
            document.getElementById('xd').classList.add('alert-danger');
        }    

        $('#mr').html(Math.round(convData(M_r,-6)));
        $('#mrd').html(Math.round(convData(M_Rd,-6)));
        $('#mom').html(Math.round(convData(M_Rd,-6)));
        $('#chi').html(Math.round(convData(eps_sup/xMrd,7))/10 + ' · 10<sup>-6</sup>');
        $('#ei_i').html(Math.round(Ec*I/Math.pow(10,10))+' · 10<sup>10</sup>');
        $('#ei_ii').html(Math.round(EI_II/Math.pow(10,10))+' · 10<sup>10</sup>');
        
        $('#epsCSup').html(Math.round(eps_sup*100000)/100);
        $('#epsCInf').html(Math.round(eps_inf*100000)/100);
        $('#epsS').html(Math.round(eps_s*100000)/100);

        if(eps_s*1000 >= 50) { // If theoretical steel rupture
            document.getElementById('epsS').classList.add('alert-danger');
        } else {
            document.getElementById('epsS').classList.remove('alert-danger');
        }

        $('#sigCSup').html(-Math.round(concrete[cType].fcd*10)/10);
        $('#sigCInf').html('-');
        $('#sigS').html(Math.round(steel[sType].fsd));

    } else {
        
        // Neuer Vektor dx_eff mit Differenz aus statischer Höhe und Druckzonenhöhe (Hebelarm Bewehrung)
        var dx_eff = math.map(x_eff, function (value) {
            return d - value;
        });

        // Dehnungen am Rand (Beton) und Bewehrung rechnen...
        eps_c = math.dotMultiply(X, x_eff);
        eps_s = math.dotMultiply(X, dx_eff);

        i = rX; //Math.max(1, rX);
        eps_cc = eps_c._data[rX] / x_eff._data[rX] * (h - x_eff._data[rX]); //Dehnung am unteren Rand (gültig aufgrund Ebenbleiben QS)

        xAxisInf = -math.max(eps_c._data) * scFacEps; // Lower limit of xAxis
        xAxisSup = Math.max((steel[sType].fsd / scFac), (eps_c._data[eps_c._data.length - 1] * Ec)) + dx; // Upper limit of xAxis

        if (eps_s._data[rX]*Es < steel[sType].fsd/scFac && scX){
            // Scale x-Axis till sig_s > fsd/scFac
            scFacX = 10;
        }
    
        // Update values...
        $('#x').html(Math.round(x_eff._data[rX]));
        
        if ( X._data[rX] > X_r2 ) {
            $('#xd').html(Math.round(x_0/d*100)/100);
            if(x_0/d <= 0.35){
                document.getElementById('xd').classList.remove('alert-warning');
                document.getElementById('xd').classList.remove('alert-danger');
            }else if(x_0/d <= 0.5){
                document.getElementById('xd').classList.remove('alert-danger');
                document.getElementById('xd').classList.add('alert-warning');
            }else{
                document.getElementById('xd').classList.remove('alert-warning');
                document.getElementById('xd').classList.add('alert-danger');
            }
        } else {
            $('#xd').html('-');
        }    
    
        $('#mr').html(Math.round(convData(M_r,-6)));
        $('#mrd').html(Math.round(convData(M_Rd,-6)));
        $('#mom').html(Math.round(convData(M._data[rX],-6)));
        $('#chi').html(Math.round(convData(X._data[rX],7))/10 + ' · 10<sup>-6</sup>');
        $('#ei_i').html(Math.round(Ec*I/Math.pow(10,10))+' · 10<sup>10</sup>');
        $('#ei_ii').html(Math.round(EI_II/Math.pow(10,10))+' · 10<sup>10</sup>');

        // Calculate vectors for stress and strain plots...
        var nAxis = { //Neutral axis...
            x: [xAxisInf, xAxisSup],
            y: [h - x_eff._data[rX], h - x_eff._data[rX]]
        };

        var eps = {
            QS: { // Strain values for cross section
                x: [0, -eps_c._data[rX] * scFacEps * scFacX, eps_cc * scFacEps * scFacX, 0],
                y: [h, h, 0, 0]
            },
            s: { // Strain values for reinforcement
                x: [0, eps_s._data[rX]*scFacEps * scFacX],
                y: [h-d, h-d]
            }
        };

        $('#epsCSup').html(Math.round(eps_c._data[rX]*100000)/100);
        $('#epsCInf').html(Math.round(eps_cc*100000)/100);
        $('#epsS').html(Math.round(eps_s._data[rX]*100000)/100);

        if(Math.round(eps_s._data[rX]*100000)/100 >= 50) { // If theoretical steel rupture
            document.getElementById('epsS').classList.add('alert-danger');
        } else {
            document.getElementById('epsS').classList.remove('alert-danger');
        }

        var sig = {s:{},c:{}};

        if (eps_cc < concrete[cType].fctm/Ec){
            // Vor dem Reissen
            sig = {
                s: { // Stress values for reinforcement
                    x: [dx, (eps_s._data[rX]*Es/scFac)*scFacX+dx],
                    y: [h-d, h-d]
                },
                c: {
                    x: [dx, eps_c._data[rX]*Ec*scFacX+dx, dx, eps_cc*Ec*scFacX+dx, dx],
                    y: [h, h, h-x_eff._data[rX], 0, 0]
                }
            };
            $('#sigCSup').html(-Math.round(eps_c._data[rX]*Ec*10)/10);
            $('#sigCInf').html(Math.round(eps_cc*Ec*10)/10);
            $('#sigS').html(Math.round(eps_s._data[rX]*Es));
        }else{
            // Nach dem Reissen
            if (!limFc || (eps_c._data[rX] < concrete[cType].fcd/Ec)) {
                sig.c = {
                    x: [dx, eps_c._data[rX]*Ec*scFacX+dx, dx],
                    y: [h, h, h-x_eff._data[rX]]
                };
                $('#sigCSup').html(-Math.round(eps_c._data[rX]*Ec*10)/10);
                $('#sigCInf').html(0);

            }else{
                sig.c = {
                    x: [dx, concrete[cType].fcd*scFacX+dx, concrete[cType].fcd*scFacX+dx, dx],
                    y: [h, h, h-(x_eff._data[rX]-concrete[cType].fcd/(X._data[rX]*Ec)), h-x_eff._data[rX]]
                };
                $('#sigCSup').html(-Math.round(concrete[cType].fcd*10)/10);
                $('#sigCInf').html(0);
            }

            sig.s = {
                x: [dx, math.min([eps_s._data[rX] * Es, steel[sType].fsd]) / scFac * scFacX + dx],
                y: [h - d, h - d]
            };
            $('#sigS').html(Math.round(math.min([eps_s._data[rX] * Es, steel[sType].fsd])));
        }
    }

    // Create new plot...
    data.plot.QS = {
        Data: [
            {   // 0: Dehnungsebene
                x: [0, 0],
                y: [0, h],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(50, 50, 50)',
                },
                fill: 'toself',
                fillcolor: 'rgba(50,50,50,0.1)',
            },
            {   // 1: Spannungsebene
                x: [dx-5,dx,dx,dx-5],
                y: [0,0,h,h],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(50, 50, 50)',
                },
                fill: 'toself',
                fillcolor: 'rgba(50,50,50,0.1)',
            },
            {   // 2: Neutralachse (grau, gestrichelt)
                x: nAxis.x,
                y: nAxis.y,
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(100, 100, 100)',
                    dash: 'dashdot',
                }
            },
            {   // 3: Dehnungen (QS, orange)
                x: eps.QS.x,
                y: eps.QS.y,
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(224, 82, 0)',
                }
            },
            {   // 4: Dehnungen (Bewehrung, blau)
                x: eps.s.x,
                y: eps.s.y,
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(10, 63, 145)',
                }
            },
            {   // 5: Betonspannungen (Grün)
                x: sig.c.x,
                y: sig.c.y,
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(10, 145, 12)',
                },
                fill: 'toself',
                fillcolor: 'rgba(10,145,12,0.2)'
            },
            {   // 6: Stahlspannungen (Blau)
                x: sig.s.x,
                y: sig.s.y,
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(10, 63, 145)',
                }
            },
            {   // 7: fcd (grau, dotted)
                x: [concrete[cType].fcd*scFacX+dx, concrete[cType].fcd*scFacX+dx],
                y: [h, 2*h/3],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(150, 150, 150)',
                    dash: 'dot',
                }
            },
            {   // 8: fsd (grau, dotted)
                x: [steel[sType].fsd / scFac * scFacX+dx, steel[sType].fsd / scFac * scFacX+dx],
                y: [0, h/3],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(150, 150, 150)',
                    dash: 'dot',
                }
            }
        ],
        Layout: {
            hovermode: false,
            height: 350,
            margin: {
                l: 60,
                r: 0,
                b: 40,
                t: 30,
                pad: 0
            },
            xaxis: {
                visible: false,
                range: [xAxisInf, xAxisSup],
            },
            yaxis: {
                visible: false,
                range: [0, h],
            },
            showlegend: false,
            annotations: [{
                yref: 'paper',
                x: 0,
                xanchor: 'middle',
                y: 0,
                yanchor: 'top',
                text: 'ε',
                font: {
                    size: 17
                },
                showarrow: false
            },{
                yref: 'paper',
                x: dx,
                xanchor: 'middle',
                y: 0,
                yanchor: 'top',
                text: 'σ',
                font: {
                    size: 17
                },
                showarrow: false
            },{
                x: concrete[cType].fcd*scFacX+dx,
                xanchor: 'middle',
                y: 2*h/3,
                yanchor: 'top',
                text: 'f<sub>cd</sub>',
                showarrow: false
            },{
                x: steel[sType].fsd/scFac*scFacX+dx,
                xanchor: 'middle',
                y: h/3,
                yanchor: 'bottom',
                text: 'f<sub>sd</sub>',
                showarrow: false
            },
            {
                x: math.min(eps.QS.x),
                xanchor: 'right',
                y: h,
                yanchor: 'middle',
                text: 'ε<sub>c,sup</sub>',
                showarrow: false
            },
            {
                x: math.max(eps.QS.x),
                xanchor: 'left',
                y: 0,
                yanchor: 'middle',
                text: 'ε<sub>c,inf</sub>',
                showarrow: false
            },
            {
                x: math.max(eps.s.x),
                xanchor: 'left',
                y: eps.s.y[0],
                yanchor: 'middle',
                text: 'ε<sub>s</sub>',
                showarrow: false
            },
            {
                x: math.max(sig.c.x),
                xanchor: 'left',
                y: h,
                yanchor: 'middle',
                text: 'σ<sub>c,sup</sub>',
                showarrow: false
            },
            {
                x: math.max(sig.s.x),
                xanchor: 'left',
                y: h-d,
                yanchor: 'middle',
                text: 'σ<sub>s</sub>',
                showarrow: false
            }],
        },
    };

    // Dash reinforcement if yielding
    /* if( eps_s._data[rX]*Es > steel[sType].fsd ) {
        data.plot.QS.Data[6].line.dash = 'dashdot';
    } */

    if(window.checkMobile() == true){
        data.plot.QS.Layout.dragmode = false;
    }

    Plotly.react("plotQS", data.plot.QS.Data, data.plot.QS.Layout, pltConfig);
}

//Converting function
function convData(data, pow){
    if(typeof data === 'object') {
        if (Array.isArray(data)) {
            return data.map(function (value) {
                return value * Math.pow(10, pow);
            });
        } else {
            return math.map(data, function (value) {
                return value * Math.pow(10, pow);
            });
        }
    }else{
        return data*Math.pow(10,pow);
    }
}